// extracted by mini-css-extract-plugin
export var columnList = "_cn-0";